import React, {
  memo,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  DeleteIcon,
  IconCoupon,
  MinusIcon,
  PlusIcon,
} from "../../../constant/icon";
import { DataContext } from "../../../contexts/DataContext";
import { useLanguage } from "../../../hooks/useLanguage";
import BaseButton from "../../button/BaseButton";
import ModalCoupon from "./ModalCoupon";

function TicketsAdded({ isHadOldOrder }) {
  const { ticketUserBuy } = useContext(DataContext);

  return (
    <div>
      {ticketUserBuy?.map((ticket, index) => {
        return (
          <ItemTicketAdded
            ticket={ticket}
            // key={ticket?.id}
            isHadOldOrder={isHadOldOrder}
            key={`${ticket?.id}desktop${index}`}
            index={index}
          />
        );
      })}
    </div>
  );
}

const ItemTicketAdded = ({ ticket, index, isHadOldOrder }) => {
  const [priceTicket, setPriceTicket] = useState("");

  const {
    onDeleteTicket,
    onInCreaseTicket,
    onDeCreaseTicket,
    setTicketUserBuy,
    ticketUserBuy,
  } = useContext(DataContext);

  const disableButtonIncCease =
    ticket?.quantity >= ticket?.limitForUser ||
    ticket?.quantity >= ticket?.remainingQuantity ||
    ticket?.quantity >= ticket?.numberCanBuy;

  const handleInCreaseTicket = useCallback(() => {
    onInCreaseTicket(index);
  }, [index, onInCreaseTicket]);
  const handleDeCreaseTicket = useCallback(() => {
    onDeCreaseTicket(index);
  }, [index, onDeCreaseTicket]);
  const handleDeleteTicket = useCallback(() => {
    onDeleteTicket(index);
  }, [index, onDeleteTicket]);

  const { nameWithLanguage, currentLanguage } = useLanguage();

  const calculateDiscount = (discountType, discountAmount, itemFee) => {
    let amount = 0;
    switch (discountType) {
      case "FIXED_AMOUNT":
        amount += discountAmount;
        break;
      case "PERCENTAGE":
        amount += (itemFee * discountAmount) / 100;
        break;
      default:
        break;
    }
    return itemFee - amount > 0 ? itemFee - amount : 0;
  };

  useEffect(() => {
    const priceTicketNew = ticket?.coupon?.couponCode
      ? calculateDiscount(
          ticket?.coupon?.discountType,
          ticket?.coupon?.discountAmount,
          +ticket?.price 
        )* +ticket?.quantity
      : +ticket?.quantity * +ticket?.price;
    setPriceTicket(priceTicketNew.toFixed(2));
  }, [ticket, +ticket?.quantity * +ticket?.price]);
  return (
    <div className="hidden border-b mb-3 w-full grid-rows-3z md:grid md:py-3 md:grid-rows-none md:grid-cols-12 gap-x-3 gap-y-2 lg:gap-y-3 md:gap-y-0">
      <div className="flex items-center col-span-4 md:grid lg:col-span-5">
        <p className="font-bold text-purple-900 text-body-1 mb-2 w-1/3">
          {ticket ? ticket[nameWithLanguage] : ""}
        </p>

        <div className="flex gap-2 items-center border border-dashed border-[#9453FF] p-1 rounded">
          <IconCoupon />
          <p className="w-full text-body-3 text-[#9453FF]">
            {ticket?.coupon?.couponName ?? "-"}
          </p>
          <ModalCoupon
            ticket={ticket}
            setTicketUserBuy={setTicketUserBuy}
            ticketUserBuy={ticketUserBuy}
          />
        </div>
      </div>

      <div className="flex items-center col-span-4 md:col-span-3 md:grid ">
        <div className="flex flex-row items-center justify-end w-full md:justify-center ">
          <div className="flex flex-row items-center gap-x-3 md:gap-x-6">
            <div>
              <BaseButton
                onClick={handleDeCreaseTicket}
                disable={isHadOldOrder ? true : ticket?.quantity <= 1}
                className="rounded-lg"
                sizeButton="small"
                variant="outline"
              >
                <MinusIcon />
              </BaseButton>
            </div>
            <p className="font-bold text-neutral-600 text-body-1">
              {ticket?.quantity}
            </p>
            <div>
              <BaseButton
                onClick={handleInCreaseTicket}
                disable={isHadOldOrder ? true : disableButtonIncCease}
                className="rounded-lg"
                sizeButton="small"
                variant="outline"
              >
                <PlusIcon />
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center w-full col-span-4 lg:col-span-3">
        <div className="flex flex-row-reverse items-center justify-between w-full md:flex-row gap-x-4 ">
          <div className="text-center">
            <p className="text-xs text-neutral-400 line-through">
              {ticket?.coupon?.couponCode &&
                (currentLanguage === "en"
                  ? `${(+ticket?.quantity * +ticket?.price).toFixed(2)} SR`
                  : `SR ${(+ticket?.quantity * +ticket?.price).toFixed(2)}`)}
            </p>
            <p className="font-bold text-neutral-800 text-body-1 ">
              {currentLanguage === "en"
                ? `${priceTicket} SR`
                : `SR ${priceTicket}`}
            </p>
          </div>
          <div className="flex-row items-end justify-between hidden md:flex ">
            <button
              disabled={isHadOldOrder}
              onClick={handleDeleteTicket}
              // className="active:ring-2 active:ring-primary-400 active:bg-none active:text-primary-200"
              className={`${
                isHadOldOrder
                  ? "opacity-30 cursor-not-allowed"
                  : "active:ring-2 active:ring-primary-400 active:bg-none active:text-primary-200"
              } `}
            >
              <DeleteIcon />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(TicketsAdded);
